import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResultWithMetadata, ISettlementProposal, ISettlementProposalQueryMetadata, ISettlementProposalsQueryParams } from 'gen/ApiClient';
import React from 'react';

export const QueryContext = React.createContext<
	IQueryContext<IQueryResultWithMetadata<ISettlementProposal, ISettlementProposalQueryMetadata>, ISettlementProposalsQueryParams>
>(undefined as any);
